export function offHoursNotice(
  time: string,
  professional: { id: string; displayName: string },
  warning: string,
): string {
  // Diz quem atende: o profissional escolhido mesmo, ou, com qualquer profissional, um dos que
  // realizam o serviço e estão livres — a API prefere quem está no expediente (ADR 0074).
  const name = professional.displayName;
  if (professional.id === 'ANY') {
    const where =
      warning === 'não atende neste dia'
        ? `Nenhum profissional que realiza este serviço atende neste dia. Se agendar às ${time},`
        : `${time} fica fora do expediente de todos os profissionais que realizam este serviço. Se agendar,`;
    return `${where} a agenda escolhe um deles que esteja livre, e o atendimento fica fora do expediente dessa pessoa.`;
  }
  if (warning === 'não atende neste dia')
    return `${name} não atende neste dia. Se agendar às ${time}, o atendimento fica com ${name} mesmo, fora do expediente.`;
  if (warning === 'fora do expediente')
    return `${time} fica fora do expediente de ${name}. Se agendar, o atendimento fica com ${name} mesmo, fora do expediente.`;
  return `${time} fica fora do expediente da sala. Se agendar, o atendimento fica nessa sala mesmo, fora do expediente dela.`;
}
